@for (item of pages; track $index) {
  @if (item.type === 'gap'){
    <a [class]="item.type"
      role="presentation"
      [tabIndex]="-1">
      {{ item.label }}
    </a>
  } @else {
    <a [class]="item.type"
      [class.disabled]="isInactive(item)"
      [class.current]="isCurrent(item)"
      [routerLink]="pageRoute"
      [queryParams]="getQueryParams(item)"
      [fragment]="fragment"
      [tabIndex]="isInactive(item) ? -1 : 0"
      (click)="pageChange(item)"
      [attr.aria-label]="getAriaLabel(item.label, item.type)">
      {{ item.label }}
    </a>
  }
}
